export default {
  bind(el, { value }) {
    el.onClickOutside = e => {
      if (el.contains(e.target)) return
      value()
    }
    document.addEventListener('click', el.onClickOutside)
  },

  unbind(el) {
    document.removeEventListener('click', el.onClickOutside)
  }
}
